import { Suspense, lazy } from 'react'

// Lazy load Three.js scene to reduce initial bundle size
const ParticleScene = lazy(() => import('./ParticleStarsScene'))

export function ParticleStars() {
  return (
    <div className="fixed inset-0 z-0 pointer-events-none">
      <Suspense fallback={
        <div className="w-full h-full" style={{ background: 'radial-gradient(circle at 50% 50%, rgba(255, 0, 255, 0.03) 0%, transparent 50%)' }} />
      }>
        <ParticleScene />
      </Suspense>
    </div>
  )
}
